import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import { toNumber } from 'lodash'
import { IconPlus, IconTrash } from '@tabler/icons-react'

import { Loader } from '@/components/loaders/Loader'
import { Button } from '@/components/buttons/Button'
import { setOrgDropdown } from '@/reducers/orgHierarchy/orghierarchy.redux'
import { fetchUpdateParentOrg } from '@/reducers/orgHierarchy/orghierarchy.actions'

export const RecursiveOrgList = ({ root }) => {
  const dispatch = useDispatch()
  const { organizationid } = useParams()
  const { loading } = useSelector((state) => state.orgHierarchy)

  const handleOpenOrgDropdown = (childOrgId) => {
    dispatch(setOrgDropdown({ parentOrgId: childOrgId, selectedChildOrgId: '' }))
  }

  const handleRemoveOrg = (childOrgId) => {
    dispatch(fetchUpdateParentOrg(null, childOrgId, organizationid))
  }

  if (!root?.children) {
    return null
  }

  if (loading) {
    return <Loader />
  }

  return (
    <ul className="org-list">
      {root.children.map((child) => (
        <li key={uuid()}>
          <div className="org-row">
            <a
              href={`/organizations/${child.organization_id}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {`${child.name} (${child.organization_id})`}
            </a>
            <div className="flex-align-center small-gap">
              <Button
                small
                square
                className="svg-button"
                onClick={() => handleOpenOrgDropdown(child.organization_id)}
                tooltip="Add Child Organization"
                tooltipProps={{ placement: 'top-end' }}
              >
                <IconPlus />
              </Button>
              {toNumber(child.organization_id) !== toNumber(organizationid) && (
                <Button
                  small
                  square
                  critical
                  className="svg-button"
                  onClick={() => handleRemoveOrg(child.organization_id)}
                  tooltip="Remove Child Organization"
                  tooltipProps={{ placement: 'top-end' }}
                >
                  <IconTrash />
                </Button>
              )}
            </div>
          </div>

          {child.children && <RecursiveOrgList root={child} />}
        </li>
      ))}
    </ul>
  )
}
